import React, { useContext, useEffect, useState } from "react";
import logo from "../photos/logo.png";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/authContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const navigate = useNavigate();
  const { currentUser, login } = useContext(AuthContext);
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(inputs);
      const redirectTo = sessionStorage.getItem("redirectTo") || "/";
      sessionStorage.removeItem("redirectTo");
      navigate(redirectTo);
    } catch (err) {
      console.log(err);
      alert("Wrong password or username!");
    }
  };

  useEffect(() => {
    if (currentUser && currentUser.isAuthenticated) {
      const redirectTo = sessionStorage.getItem("redirectTo") || "/";
      sessionStorage.removeItem("redirectTo");
      navigate(redirectTo);
    }
  }, [currentUser]);

  return (
    <div className="bodyContent justified">
      <div className="centered loginCentered">
        <img src={logo} alt="Logo Innexo" className="block logoBig" />
        <form action="/" method="post" className="loginForm">
          <div className="username">
            <p className="loginText">Email</p>
            <input
              type="text"
              name="email"
              id="email"
              className="loginInput"
              onChange={handleChange}
              autoComplete="email"
            />
          </div>
          <div className="password">
            <p className="loginText">Password</p>
            <div className="passwordInputContainer" style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                id="password"
                className="loginInput"
                onChange={handleChange}
                autoComplete="current-password"
                style={{ paddingRight: '35px' }}
              />
              <div style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer'
              }}>
                {showPassword ? (
                  <FaEyeSlash
                    className="passwordToggleIcon"
                    onClick={() => setShowPassword(false)}
                  />
                ) : (
                  <FaEye
                    className="passwordToggleIcon"
                    onClick={() => setShowPassword(true)}
                  />
                )}
              </div>
            </div>
          </div>
          <input
            type="submit"
            value="Login"
            className="block loginBtn"
            onClick={handleSubmit}
          />
          <div className="rememberMe">
            <input type="checkbox" className="maintenanceCheckbox maintenanceTableCheckbox" name="RembemberMe" id="member" />
            <p className="inline-block memberText" style={{marginLeft: "10px"}}>Remember Me</p>
          </div>
        </form>
        </div>
      </div>
  );
}

export default Login;